module.exports = __webpack_public_path__ + "img/Slide.9464d07e.png";